// config.js
const apiUrl = 'https://kidstoy.onrender.com'; // Replace with your actual API base URL
export default apiUrl;
   
